// This file was automatically generated from render.chartFeedItem.visitNoteTemplate.oneCol.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.chartFeedItem.visitNoteTemplate.oneCol');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.core');
goog.require('el8.template.render.chartFeedItem.visitNoteContent');
goog.require('el8.template.render.chartFeedItem.visitNoteShared');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.visitNoteTemplate.oneCol.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="cardColumn w100">');
  if (opt_data.template == 'oneCol.oneField') {
    el8.template.render.chartFeedItem.visitNoteTemplate.oneCol.sectionObjective(soy.$$augmentData(opt_data.objective, {templateTypeMap: opt_data.templateTypeMap, isEdit: opt_data.isEdit}), output);
    el8.template.render.chartFeedItem.visitNoteTemplate.oneCol.sectionSubjective(soy.$$augmentData(opt_data.subjective, {templateTypeMap: opt_data.templateTypeMap, isEdit: opt_data.isEdit}), output);
  } else {
    el8.template.render.chartFeedItem.visitNoteTemplate.oneCol.sectionSubjective(soy.$$augmentData(opt_data.subjective, {templateTypeMap: opt_data.templateTypeMap, isEdit: opt_data.isEdit}), output);
    el8.template.render.chartFeedItem.visitNoteTemplate.oneCol.sectionObjective(soy.$$augmentData(opt_data.objective, {templateTypeMap: opt_data.templateTypeMap, isEdit: opt_data.isEdit}), output);
  }
  if (opt_data.objective.referenceds.length > 0) {
    output.append('<fieldset class="noBorderForm"><div class="fieldNoteSection collapsible-section"><p class="fieldTitle">Documents Referenced:</p><ol class="el8FieldShortLabelPadding">');
    var itemList26466 = opt_data.objective.referenceds;
    var itemListLen26466 = itemList26466.length;
    for (var itemIndex26466 = 0; itemIndex26466 < itemListLen26466; itemIndex26466++) {
      var itemData26466 = itemList26466[itemIndex26466];
      el8.template.core.listItem(soy.$$augmentData(itemData26466, {triggerClass: itemData26466.itemId && ! opt_data.isEdit ? 'item-details-trigger itemTrigger' : null}), output);
    }
    output.append('</ol></div></fieldset>');
  }
  el8.template.render.chartFeedItem.visitNoteTemplate.oneCol.sectionAssessment(soy.$$augmentData(opt_data.assessment, {templateTypeMap: opt_data.templateTypeMap, isEdit: opt_data.isEdit}), output);
  el8.template.render.chartFeedItem.visitNoteTemplate.oneCol.sectionPlan(soy.$$augmentData(opt_data.plan, {templateTypeMap: opt_data.templateTypeMap, isEdit: opt_data.isEdit}), output);
  el8.template.render.chartFeedItem.visitNoteContent.sectionFollowup({followup: opt_data.followup}, output);
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.visitNoteTemplate.oneCol.sectionSubjective = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.narrative || opt_data.problems.length > 0 || opt_data.pastItems.length > 0 || opt_data.surgicalItems.length > 0 || opt_data.hpiItems.length > 0 || opt_data.allergies.length > 0 || opt_data.habitsItems.length > 0 || opt_data.familyItems.length > 0 || opt_data.socialItems.length > 0 || opt_data.vniMeds.length > 0 || opt_data.rosItems.length > 0 || opt_data.rosDetails.length > 0) {
    output.append('<fieldset class="noBorderForm">');
    el8.template.render.chartFeedItem.visitNoteShared.field({items: opt_data.problems, label: 'Prob:', collapsible: false, type: opt_data.templateTypeMap.problem, isEdit: opt_data.isEdit, isOneCol: true}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({items: opt_data.hpiItems, label: 'HPI:', type: opt_data.templateTypeMap.hpi, isEdit: opt_data.isEdit, isOneCol: true}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({items: opt_data.allergies, label: 'Allergies:', type: opt_data.templateTypeMap.allergies, isEdit: opt_data.isEdit, isOneCol: true}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({items: opt_data.pastItems, label: 'PMH:', type: opt_data.templateTypeMap.past, isEdit: opt_data.isEdit, isOneCol: true}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({items: opt_data.surgicalItems, label: 'PSH:', type: opt_data.templateTypeMap.surgical, isEdit: opt_data.isEdit, isOneCol: true}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({label: 'FH:', items: opt_data.familyItems, type: opt_data.templateTypeMap.family, isEdit: opt_data.isEdit, isOneCol: true}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({label: 'SH:', items: opt_data.socialItems, type: opt_data.templateTypeMap.social, isEdit: opt_data.isEdit, isOneCol: true}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({label: 'Habits:', items: opt_data.habitsItems, type: opt_data.templateTypeMap.habits, isEdit: opt_data.isEdit, isOneCol: true}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({label: 'Current Medications:', items: opt_data.vniMeds, type: opt_data.templateTypeMap.med, isEdit: opt_data.isEdit, isOneCol: true}, output);
    el8.template.render.chartFeedItem.visitNoteShared.checklist({label: 'ROS:', items: opt_data.rosItems, details: opt_data.rosDetails, type: opt_data.templateTypeMap.ros, isOneCol: true}, output);
    output.append((opt_data.narrative.text || opt_data.narrative.textReplaced) ? '<div class="fieldNoteSection"><p class="el8Wrap el8Preserve">' + ((opt_data.narrative.textReplaced) ? '<span class="el8Strike">' + soy.$$escapeHtml(opt_data.narrative.textReplaced) + '</span> ' : '') + ((opt_data.narrative.isEdit) ? '<span class="el8Edit">' + (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.narrative.text)) : soy.$$escapeHtml(opt_data.narrative.text)) + '</span>' : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.narrative.text)) : soy.$$escapeHtml(opt_data.narrative.text))) + '</p></div>' : '', '</fieldset>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.visitNoteTemplate.oneCol.sectionObjective = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.objectives.length > 0 || opt_data.allDatas.length > 0 || opt_data.peItems.length > 0 || opt_data.peDetails.length > 0 || opt_data.vitals.hasVitals) {
    output.append('<fieldset class="noBorderForm">');
    el8.template.render.chartFeedItem.visitNoteContent.sectionVitals(opt_data.vitals, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({items: opt_data.objectives, label: 'Objective:', collapsible: false, type: opt_data.templateTypeMap.objective, isEdit: opt_data.isEdit, isOneCol: true}, output);
    el8.template.render.chartFeedItem.visitNoteShared.checklist({label: 'PE:', items: opt_data.peItems, details: opt_data.peDetails, type: opt_data.templateTypeMap.pe, isOneCol: true}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({items: opt_data.allDatas, label: 'Data:', type: opt_data.templateTypeMap.data, isEdit: opt_data.isEdit, isOneCol: true}, output);
    output.append('</fieldset>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.visitNoteTemplate.oneCol.sectionAssessment = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.assessments.length > 0 || opt_data.assessplans.length > 0) {
    output.append('<fieldset class="noBorderForm">');
    el8.template.render.chartFeedItem.visitNoteShared.field({items: opt_data.assessments, collapsible: false, label: 'Assessment:', feedItemId: opt_data.feedItemId, isAssessment: true, type: opt_data.templateTypeMap.assessment, isEdit: opt_data.isEdit, isOneCol: true}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({items: opt_data.assessplans, collapsible: false, label: 'Assessment/Plan:', feedItemId: opt_data.feedItemId, isAssessment: true, type: opt_data.templateTypeMap.assessplan, isEdit: opt_data.isEdit, isOneCol: true}, output);
    output.append('</fieldset>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.visitNoteTemplate.oneCol.sectionPlan = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.plans.length > 0 || opt_data.tests.length > 0 || opt_data.txs.length > 0 || opt_data.instructions.length > 0 || opt_data.orders.length > 0 || opt_data.procedures.length > 0) {
    output.append('<fieldset class="noBorderForm">');
    el8.template.render.chartFeedItem.visitNoteShared.field({items: opt_data.plans, label: 'Plan:', collapsible: false, type: opt_data.templateTypeMap.plan, isEdit: opt_data.isEdit, isOneCol: true}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({label: 'Tests:', items: opt_data.tests, collapsible: false, type: opt_data.templateTypeMap.test, isEdit: opt_data.isEdit, isOneCol: true}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({label: 'Tx:', items: opt_data.txs, collapsible: false, type: opt_data.templateTypeMap.tx, isEdit: opt_data.isEdit, isOneCol: true}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({label: 'Proc:', items: opt_data.procedures, collapsible: false, type: opt_data.templateTypeMap.procedure, isEdit: opt_data.isEdit, isOneCol: true}, output);
    if (opt_data.orders.length > 0) {
      output.append('<div class="fieldNoteSaved"><p class="fieldTitle">Orders:</p><ol>');
      var itemList26647 = opt_data.orders;
      var itemListLen26647 = itemList26647.length;
      for (var itemIndex26647 = 0; itemIndex26647 < itemListLen26647; itemIndex26647++) {
        var itemData26647 = itemList26647[itemIndex26647];
        el8.template.core.listItem(soy.$$augmentData(itemData26647, {triggerClass: itemData26647.itemId && ! opt_data.isEdit ? 'item-details-trigger itemTrigger' : null}), output);
      }
      output.append('</ol></div>');
    }
    el8.template.render.chartFeedItem.visitNoteShared.field({label: 'Care Plan:', items: opt_data.instructions, collapsible: false, type: opt_data.templateTypeMap.instr, isEdit: opt_data.isEdit, isOneCol: true}, output);
    output.append('</fieldset>');
  }
  if (!opt_sb) return output.toString();
};
